import { IToken } from '../../interfaces'

export const addTokenAction = (token: IToken) => token

export const clearTokenAccessAction = (): IToken => ({
  tokenType: '',
  accessToken: ''
})
